export default [
  { name: 'Programs', pathRegEx: /^\/my-school\/programs/, schoolSetting: settings => settings.enable_programs }
];
